module.exports = __webpack_public_path__ + "assets/img/cricket-next.008a1c61.png";